<script setup lang="ts">
const { t } = useEkI18n();
const settingsStore = useSettingsStore();

async function updateOpenProjectOnCreationPreference(value: boolean) {
  await settingsStore.set('openProjectOnCreation', value);
}
</script>

<template>
  <SettingsToggle
    :checked="settingsStore.settings.openProjectOnCreation"
    :label="t('settings.projects.openOnCreation')"
    :description="t('settings.projects.openOnCreationDescription')"
    @change="updateOpenProjectOnCreationPreference"
  />
</template>
